"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_apollo_1 = require("react-apollo");
const servicePlatformQuery = require("./service-platform.query.graphql");
const utilities_1 = require("../utilities");
class PlatformRestrictionView extends React.Component {
    render() {
        const { children, loadingContent, shouldRender } = this.props;
        if (this.props.data.loading) {
            return loadingContent || null;
        }
        const platform = this.props.data.service && this.props.data.service.metadata
            ? this.props.data.service.metadata.platform || ""
            : "";
        if (shouldRender(platform)) {
            return children;
        }
        else {
            return null;
        }
    }
}
exports.PlatformRestriction = utilities_1.compose(react_apollo_1.graphql(servicePlatformQuery))(PlatformRestrictionView);
